import { useQueries } from '@tanstack/react-query';
import { getConnectorTools } from '@terminal/services/alfred-intergations/alfred-integrations-service';

export const QUERY_KEY_CONNECTOR_TOOLS = 'QUERY_KEY_CONNECTOR_TOOLS';

export const useConnectorRegistryProviderIds = (connectorIds: string[]) =>
  useQueries({
    queries: connectorIds.map(connectorId => ({
      queryKey: [QUERY_KEY_CONNECTOR_TOOLS, connectorId],
      queryFn: () => getConnectorTools(connectorId),
      select: (response: Awaited<ReturnType<typeof getConnectorTools>>) =>
        response.data?.providerId,
    })),
    combine: results =>
      Object.fromEntries(
        results.flatMap((result, index) =>
          result.data ? [[connectorIds[index], result.data]] : []
        )
      ) as Record<string, string>,
  });
